const auraBgList = [
  ////0-6
  {
    auraBg: "card-backgrounds/common-cardbg-01.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-02.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-03.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-04.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-05.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-06.webp",
  },
  {
    auraBg: "card-backgrounds/common-cardbg-07.webp",
  },
  ////////7-28
  {
    auraBg: "card-backgrounds/cardbg-01.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-02.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-03.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-04.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-05.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-06.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-07.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-08.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-09.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-10.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-11.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-12.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-13.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-14.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-15.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-16.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-17.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-18.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-19.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-20.webp",
  },
  {
    auraBg: "card-backgrounds/cardbg-21.webp",
  },
];

export default auraBgList;
